import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    const exchange = async () => {
      try {
        const { data } = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        navigate(location.pathname, { state: { user: data }, replace: true });
      } catch (e) {
        const status = e?.response?.status;
        navigate(status === 403 ? `${location.pathname}?denied=1` : `${location.pathname}?error=1`, { replace: true });
      }
    };
    exchange();
  }, [location, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-sand" data-testid="auth-callback">
      <p className="text-sm font-medium text-ink/50">Signing you in…</p>
    </div>
  );
};

export default AuthCallback;
